export default () => {
    const article = document.querySelector(".type-page");

    if (article) {
        const faqs = document.querySelectorAll(".faqs__faq");

        if (faqs) {
            faqs.forEach((faq) => {
                faq.addEventListener("click", () => {
                    faq.classList.toggle("is-open");
                });
            });
        }
    }
};